import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CausaliMovMag } from 'src/app/models/causali-movmag';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CausaliMovmagService {
  private http = inject(HttpClient);

  dpiUrl = environment.ildatoArticoliDpi + 'api/causaliMovMag';

  private _listCausaliMovMagTempSubject = new BehaviorSubject<CausaliMovMag[] | undefined>(
    undefined
  );
  private _causaleMovMagDefInsTempSubject = new BehaviorSubject<CausaliMovMag | undefined>(
    undefined,
  );

  list(): Observable<CausaliMovMag[]> {
    return this.http.get<CausaliMovMag[]>(`${this.dpiUrl}`);
  }

  get(id: number): Observable<CausaliMovMag> {
    return this.http.get<CausaliMovMag>(`${this.dpiUrl}/${id}`);
  }

  post(values: CausaliMovMag): Observable<CausaliMovMag> {
    return this.http.post<CausaliMovMag>(`${this.dpiUrl}`, values);
  }

  update(key: number, values: CausaliMovMag): Observable<CausaliMovMag> {
    return this.http.put<CausaliMovMag>(`${this.dpiUrl}/${key}`, values);
  }

  remove(key: number): Observable<CausaliMovMag> {
    return this.http.delete<CausaliMovMag>(`${this.dpiUrl}/${key}`);
  }

  getListCausaliMovMagTemp(forceRefresh = false): Observable<CausaliMovMag[]> {
    if (
      this._listCausaliMovMagTempSubject.value == undefined ||
      forceRefresh
    ) {
      this.http.get<CausaliMovMag[]>(this.dpiUrl).subscribe({
        next: (res) => {
          this._listCausaliMovMagTempSubject.next(res);
        },
        error: (error) => {
          console.log('Errore caricamento causali mov mag temp: ' + error);
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore caricamento causali mov mag temp', 'warning');
          }
        },
      });
    }
    return this._listCausaliMovMagTempSubject
      .asObservable()
      .pipe(filter((r) => r != null));
  }

  getCausaleMovMagDefInsTemp(forceRefresh = false): Observable<CausaliMovMag> {
    if (
      this._causaleMovMagDefInsTempSubject.value == undefined || 
      forceRefresh
    ) {
      this.http
        .get<CausaliMovMag>(this.dpiUrl + '/default/inserimento')
        .subscribe({
          next: (res) => {
            this._causaleMovMagDefInsTempSubject.next(res);
          },
          error: (error) => {
            console.log(
              'Errore caricamento causali mov mag def ins temp: ' + error,
            );
            if (error?.status == 500 && error?.error?.title) {
              notify(error?.error?.title, 'warning');
            } else {
              notify(
                'Errore caricamento causali mov mag def ins temp',
                'warning',
              );
            }
          },
        });
    }
    return this._causaleMovMagDefInsTempSubject
      .asObservable()
      .pipe(filter((r) => r != null));
  }

  cleanTemp(){
    this._causaleMovMagDefInsTempSubject.next(undefined);
    this._listCausaliMovMagTempSubject.next(undefined);
  }
}
